import { defineMessages } from 'react-intl'

const messages = defineMessages({
  subscribeCTA: {
    id: 'subscription.subscribe-cta',
  },
  email: {
    id: 'global.email',
  },
  thankYou: {
    id: 'global.thank-you',
  },
  willReceiveEmail: {
    id: 'subscription.we-have-sent-you-an-email',
  },
  alreadySubscribed: {
    id: 'subscription.thank-you!',
  },
  thankYouSubscription: {
    id: 'subscription.thank-you-for-being-part-of-our-community',
  },
  error: {
    id: 'error.default',
  },
  subscribeTitle: {
    id: 'subscription.subscribe-to-get-unique-discounts',
  },
  subscribeSubTitle: {
    id: 'subscription.on-our-newsletter',
  },
})

export default messages
